<div class="panel-menu-list {{layout}}-menu" *ngFor="let layout of layouts">
    <div *ngFor="let button of buttons[layout]" (click)="clickItem(button)">
        <img [src]="button.icon | gameurl" class="main-button" />
    </div>
    <div class="panel-menu-item" *ngIf="fullscreen && layout === 'top-left'">
        <app-fullscreen-toggle>
            <img [src]="fullscreen" class="main-button" />
        </app-fullscreen-toggle>
    </div>
</div>